import { useEffect } from 'react'

import {
  OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_EVENT__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_EVENT_REMINDERS__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_FIELD_CONDITION__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_GROUP_CONDITION__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_ONBOARDING__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_RECIPIENT_ACTIVITY__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_SUBSCRIPTION_DATE__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_THANKS_FOR_JOIN__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES__VALUE
} from 'Constants'
import { notifyParent } from 'Helpers/notifyParent'
import svgUnsubscriptionCampaign from 'Img/workflow__unsubscription_campaigns.svg'
import {
  Badge,
  BADGE_TYPE_SUCCESS,
  Card,
  Flex,
  Grid,
  GridCell,
  SPACING_24,
  SpacingVertical,
  Text,
  TEXT_VARIANT_SMALL,
  TEXT_VARIANT_SMALL_LIGHT,
  Title,
  TITLE_VARIANT_S,
  TooltipUtils
} from 'mailup-web-components'
import svgCake from 'mailup-web-components/resources/mailup-web-app/img/svg/cake.svg'
import svgCalendar from 'mailup-web-components/resources/mailup-web-app/img/svg/calendar.svg'
import svgChart from 'mailup-web-components/resources/mailup-web-app/img/svg/chart.svg'
import svgEmail from 'mailup-web-components/resources/mailup-web-app/img/svg/email.svg'
import svgGroup from 'mailup-web-components/resources/mailup-web-app/img/svg/group.svg'
import svgIdea from 'mailup-web-components/resources/mailup-web-app/img/svg/idea.svg'
import svgInbox from 'mailup-web-components/resources/mailup-web-app/img/svg/inbox.svg'
import svgListPaper from 'mailup-web-components/resources/mailup-web-app/img/svg/list-paper.svg'
import svgUserData from 'mailup-web-components/resources/mailup-web-app/img/svg/user-data.svg'
import svgUserSelected from 'mailup-web-components/resources/mailup-web-app/img/svg/user-selected.svg'
import svgWelcomeSeries from 'mailup-web-components/resources/mailup-web-app/img/svg/welcome-series.svg'

import { step1ToStep2Callback } from 'Pages/Workflow/recoil/callbacks/callbacks'
import { workflowDetails } from 'Pages/Workflow/recoil/state/data'
import {
  modalExistWelcomeSeriesWorkflow,
  modalWelcomeMessageNotEnabled
} from 'Pages/Workflow/recoil/state/modals'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'

import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'
import { ModalExistWelcomeSeriesWorkflow } from './Modals/ModalExistWelcomeSeriesWorkflow'
import { ModalWelcomeMessageNotEnabled } from './Modals/ModalWelcomeMessageNotEnabled'

const WorkflowWizardFirstStep = () => {
  const intl = useIntl()
  const history = useHistory()

  const handleCard = useRecoilCallback(step1ToStep2Callback, [])
  const { Type: workflowDetailsType } = useRecoilValue(workflowDetails)

  // Modal ExistWelcomeSeriesWorkflow
  const [
    {
      show: showModalExistWelcomeSeriesWorkflow,
      id: idModalExistWelcomeSeriesWorkflow
    },
    setExistWelcomeSeriesWorkflow
  ] = useRecoilState(modalExistWelcomeSeriesWorkflow)
  const handleModalExistWelcomeSeriesWorkflowCancel = () => {
    setExistWelcomeSeriesWorkflow((prev) => ({
      ...prev,
      show: false
    }))
  }
  const handleModalExistWelcomeSeriesWorkflowConfirm = () => {
    setExistWelcomeSeriesWorkflow((prev) => ({
      ...prev,
      show: false
    }))
    history.push(
      `/automation/workflow/${idModalExistWelcomeSeriesWorkflow}/edit`
    )
  }

  // Modal WelcomeMessageNotEnabled
  const [
    { show: showModalWelcomeMessageNotEnabled },
    setModalWelcomeMessageNotEnabled
  ] = useRecoilState(modalWelcomeMessageNotEnabled)
  const handleModalWelcomeMessageNotEnabledsCancel = () => {
    setModalWelcomeMessageNotEnabled((prev) => ({
      ...prev,
      show: false
    }))
  }
  const handleModalWelcomeMessageNotEnabledConfirm = () => {
    notifyParent('redirectMainFrame', [
      'databasebuilding_app_redirector.aspx?r=/databasebuilding/subscriptions/welcome/list'
    ])
  }

  useEffect(() => {
    setTimeout(TooltipUtils.rebuild, 500)
  }, [])

  return (
    <>
      <ModalExistWelcomeSeriesWorkflow
        show={showModalExistWelcomeSeriesWorkflow}
        handleCancel={handleModalExistWelcomeSeriesWorkflowCancel}
        handleConfirm={handleModalExistWelcomeSeriesWorkflowConfirm}
      />
      <ModalWelcomeMessageNotEnabled
        show={showModalWelcomeMessageNotEnabled}
        handleCancel={handleModalWelcomeMessageNotEnabledsCancel}
        handleConfirm={handleModalWelcomeMessageNotEnabledConfirm}
      />
      {
        // PRECONFIGURED:
      }
      <>
        <Title variant={TITLE_VARIANT_S}>
          {intl.formatMessage({
            id: 'Load.AutomationWorkflow.PreconfiguredWorkflowTitle'
          })}
        </Title>
        <Text variant={TEXT_VARIANT_SMALL}>
          {intl.formatMessage({
            id: 'Load.AutomationWorkflow.PreconfiguredWorkflow'
          })}
        </Text>
        <SpacingVertical variant={SPACING_24} />

        <Grid cols={12}>
          <GridCell span={3}>
            <Card
              onClick={() =>
                handleCard(OPT_WORKFLOWS_LIST_TYPE_THANKS_FOR_JOIN__VALUE)
              }
              selected={
                workflowDetailsType ===
                OPT_WORKFLOWS_LIST_TYPE_THANKS_FOR_JOIN__VALUE
              }
              data-mu-test='e-card-element'
            >
              <img width={100} src={svgInbox} />
              <Flex justifyContent='center' alignItems='center' margin='8px  0'>
                <Title variant={TITLE_VARIANT_S}>
                  {intl.formatMessage({
                    id: 'Load.AutomationWorkflow.TitleType6'
                  })}
                </Title>
              </Flex>
              <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
                {intl.formatMessage({
                  id: 'Load.AutomationWorkflow.DescriptionType6'
                })}
              </Text>
            </Card>
          </GridCell>

          <GridCell span={3}>
            <Card
              onClick={() =>
                handleCard(OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES__VALUE)
              }
              selected={
                workflowDetailsType ===
                OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES__VALUE
              }
              data-mu-test='e-card-element'
            >
              <img width={100} src={svgWelcomeSeries} />
              <Flex justifyContent='center' alignItems='center' margin='8px  0'>
                <Title variant={TITLE_VARIANT_S}>
                  {intl.formatMessage({
                    id: 'Load.AutomationWorkflow.TitleType11'
                  })}
                </Title>
              </Flex>
              <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
                {intl.formatMessage({
                  id: 'Load.AutomationWorkflow.DescriptionType11'
                })}
              </Text>
            </Card>
          </GridCell>

          <GridCell span={3}>
            <Card
              onClick={() =>
                handleCard(OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY__VALUE)
              }
              selected={
                workflowDetailsType === OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY__VALUE
              }
              data-mu-test='e-card-element'
            >
              <img width={100} src={svgCake} />
              <Flex justifyContent='center' alignItems='center' margin='8px  0'>
                <Title variant={TITLE_VARIANT_S}>
                  {intl.formatMessage({
                    id: 'Load.AutomationWorkflow.TitleType8'
                  })}
                </Title>
              </Flex>
              <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
                {intl.formatMessage({
                  id: 'Load.AutomationWorkflow.DescriptionType8'
                })}
              </Text>
            </Card>
          </GridCell>

          <GridCell span={3}>
            <Card
              onClick={() =>
                handleCard(OPT_WORKFLOWS_LIST_TYPE_EVENT_REMINDERS__VALUE)
              }
              selected={
                workflowDetailsType ===
                OPT_WORKFLOWS_LIST_TYPE_EVENT_REMINDERS__VALUE
              }
              data-mu-test='e-card-element'
            >
              <img width={100} src={svgIdea} />
              <Flex justifyContent='center' alignItems='center' margin='8px  0'>
                <Title variant={TITLE_VARIANT_S}>
                  {intl.formatMessage({
                    id: 'Load.AutomationWorkflow.TitleType9'
                  })}
                </Title>
              </Flex>
              <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
                {intl.formatMessage({
                  id: 'Load.AutomationWorkflow.DescriptionType9'
                })}
              </Text>
            </Card>
          </GridCell>
        </Grid>

        <SpacingVertical variant={SPACING_24} />

        <Grid cols={12}>
          <GridCell span={3}>
            <Card
              onClick={() =>
                handleCard(OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART__VALUE)
              }
              selected={
                workflowDetailsType ===
                OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART__VALUE
              }
              data-mu-test='e-card-element'
            >
              <img width={100} src={svgChart} />
              <Flex justifyContent='center' alignItems='center' margin='8px  0'>
                <Title variant={TITLE_VARIANT_S}>
                  {intl.formatMessage({
                    id: 'Load.AutomationWorkflow.TitleType10'
                  })}
                </Title>
              </Flex>
              <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
                {intl.formatMessage({
                  id: 'Load.AutomationWorkflow.DescriptionType10'
                })}
              </Text>
            </Card>
          </GridCell>

          <GridCell span={3}>
            <Card
              onClick={() =>
                handleCard(OPT_WORKFLOWS_LIST_TYPE_ONBOARDING__VALUE)
              }
              selected={
                workflowDetailsType ===
                OPT_WORKFLOWS_LIST_TYPE_ONBOARDING__VALUE
              }
              data-mu-test='e-card-element'
            >
              <img width={100} src={svgListPaper} />
              <Flex justifyContent='center' alignItems='center' margin='8px  0'>
                <Title variant={TITLE_VARIANT_S}>
                  {intl.formatMessage({
                    id: 'Load.AutomationWorkflow.TitleType7'
                  })}
                </Title>
              </Flex>
              <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
                {intl.formatMessage({
                  id: 'Load.AutomationWorkflow.DescriptionType7'
                })}
              </Text>
            </Card>
          </GridCell>

          <GridCell span={3}>
            <Card
              onClick={() => {
                handleCard(
                  OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE
                )
              }}
              selected={
                workflowDetailsType ===
                OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE
              }
              data-mu-test='e-card-element'
              childrenAbsoluteCorner={
                <Badge
                  type={BADGE_TYPE_SUCCESS}
                  text={intl.formatMessage({ id: 'Load.MailupCommon.New' })}
                />
              }
            >
              <img width={100} src={svgUnsubscriptionCampaign} />
              <Flex justifyContent='center' alignItems='center' margin='8px  0'>
                <Title variant={TITLE_VARIANT_S}>
                  {intl.formatMessage({
                    id: 'Load.AutomationWorkflow.TitleTypeUnsubscriptionCampaign'
                  })}
                </Title>
              </Flex>
              <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
                {intl.formatMessage({
                  id: 'Load.AutomationWorkflow.DescriptionTypeUnsubscriptionCampaign'
                })}
              </Text>
            </Card>
          </GridCell>
        </Grid>
      </>
      <SpacingVertical variant={SPACING_24} />
      <SpacingVertical variant={SPACING_24} />
      {
        // CUSTOM:
      }
      <>
        <Title variant={TITLE_VARIANT_S}>
          {intl.formatMessage({
            id: 'Load.AutomationWorkflow.CustomWorkflowTitle'
          })}
        </Title>
        <Text variant={TEXT_VARIANT_SMALL}>
          {intl.formatMessage({
            id: 'Load.AutomationWorkflow.CustomWorkflow'
          })}
        </Text>
        <SpacingVertical variant={SPACING_24} />

        <Grid cols={12}>
          <GridCell span={3}>
            <Card
              onClick={() => handleCard(OPT_WORKFLOWS_LIST_TYPE_EVENT__VALUE)}
              selected={
                workflowDetailsType === OPT_WORKFLOWS_LIST_TYPE_EVENT__VALUE
              }
              data-mu-test='e-card-element'
            >
              <img width={100} src={svgCalendar} />
              <Flex justifyContent='center' alignItems='center' margin='8px  0'>
                <Title variant={TITLE_VARIANT_S}>
                  {intl.formatMessage({
                    id: 'Load.AutomationWorkflow.TitleType1'
                  })}
                </Title>
              </Flex>
              <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
                {intl.formatMessage({
                  id: 'Load.AutomationWorkflow.DescriptionType1'
                })}
              </Text>
            </Card>
          </GridCell>

          <GridCell span={3}>
            <Card
              onClick={() =>
                handleCard(OPT_WORKFLOWS_LIST_TYPE_SUBSCRIPTION_DATE__VALUE)
              }
              selected={
                workflowDetailsType ===
                OPT_WORKFLOWS_LIST_TYPE_SUBSCRIPTION_DATE__VALUE
              }
              data-mu-test='e-card-element'
            >
              <img width={100} src={svgEmail} />
              <Flex justifyContent='center' alignItems='center' margin='8px  0'>
                <Title variant={TITLE_VARIANT_S}>
                  {intl.formatMessage({
                    id: 'Load.AutomationWorkflow.TitleType2'
                  })}
                </Title>
              </Flex>
              <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
                {intl.formatMessage({
                  id: 'Load.AutomationWorkflow.DescriptionType2'
                })}
              </Text>
            </Card>
          </GridCell>

          <GridCell span={3}>
            <Card
              onClick={() =>
                handleCard(OPT_WORKFLOWS_LIST_TYPE_FIELD_CONDITION__VALUE)
              }
              selected={
                workflowDetailsType ===
                OPT_WORKFLOWS_LIST_TYPE_FIELD_CONDITION__VALUE
              }
              data-mu-test='e-card-element'
            >
              <img width={100} src={svgUserSelected} />
              <Flex justifyContent='center' alignItems='center' margin='8px  0'>
                <Title variant={TITLE_VARIANT_S}>
                  {intl.formatMessage({
                    id: 'Load.AutomationWorkflow.TitleType3'
                  })}
                </Title>
              </Flex>
              <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
                {intl.formatMessage({
                  id: 'Load.AutomationWorkflow.DescriptionType3'
                })}
              </Text>
            </Card>
          </GridCell>

          <GridCell span={3}>
            <Card
              onClick={() =>
                handleCard(OPT_WORKFLOWS_LIST_TYPE_GROUP_CONDITION__VALUE)
              }
              selected={
                workflowDetailsType ===
                OPT_WORKFLOWS_LIST_TYPE_GROUP_CONDITION__VALUE
              }
              data-mu-test='e-card-element'
            >
              <img width={100} src={svgGroup} />
              <Flex justifyContent='center' alignItems='center' margin='8px  0'>
                <Title variant={TITLE_VARIANT_S}>
                  {intl.formatMessage({
                    id: 'Load.AutomationWorkflow.TitleType4'
                  })}
                </Title>
              </Flex>
              <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
                {intl.formatMessage({
                  id: 'Load.AutomationWorkflow.DescriptionType4'
                })}
              </Text>
            </Card>
          </GridCell>
        </Grid>

        <SpacingVertical variant={SPACING_24} />

        <Grid cols={12}>
          <GridCell span={3}>
            <Card
              onClick={() =>
                handleCard(OPT_WORKFLOWS_LIST_TYPE_RECIPIENT_ACTIVITY__VALUE)
              }
              selected={
                workflowDetailsType ===
                OPT_WORKFLOWS_LIST_TYPE_RECIPIENT_ACTIVITY__VALUE
              }
              data-mu-test='e-card-element'
            >
              <img width={100} src={svgUserData} />
              <Flex justifyContent='center' alignItems='center' margin='8px  0'>
                <Title variant={TITLE_VARIANT_S}>
                  {intl.formatMessage({
                    id: 'Load.AutomationWorkflow.TitleType5'
                  })}
                </Title>
              </Flex>
              <Text variant={TEXT_VARIANT_SMALL_LIGHT}>
                {intl.formatMessage({
                  id: 'Load.AutomationWorkflow.DescriptionType5'
                })}
              </Text>
            </Card>
          </GridCell>
        </Grid>
      </>
    </>
  )
}

export default WorkflowWizardFirstStep
